<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"
         [isPanelOpened]="isActivePanelOpened"
         [accordionHeading]="tablesTranslations.i18nActiveLotteryRounds"
         [spinnerName]="spinnerName"
         [emptyStateIcon]="'#esf-icon-dollar-check'"
         [emptyStateText]="tablesTranslations.i18nNoIterations"
         (panelTriggerClickEvent)="isActivePanelOpened = !isActivePanelOpened"
         [data]="executionIterations"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>

<div class="esf-accordion__trigger" [class.-is-open]="isCompletedPanelOpened" (click)="isCompletedPanelOpened = !isCompletedPanelOpened">
  <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
    <span class="esf-action-heading__text">{{ tablesTranslations.i18nCompletedLotteryRounds }}</span>
  </h4>
</div>
<div class="esf-accordion__target -is-open" [hidden]="!isCompletedPanelOpened">
  <div class="esf-info-tile esf-info-tile--full-width">
    <div class="esf-info-tile__content">
      <app-paginated-table [columns]="columns"
                           [keys]="keys"
                           [data]="completedExecutionIterations"

                           [baseApi]="baseApi"
                           [customQueries]="customQueries"
                           (dataFetchedEmitter)="createSubmissionObject($event)"

                           [emptyStateText]="tablesTranslations.i18nNoIterations"
                           [emptyStateIcon]="'#esf-icon-dollar-check'">

      </app-paginated-table>
    </div>
  </div>
</div>
